import styled from '@emotion/styled'
import { colors } from '../../__styling'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledTW1000PromoBannerWrap = styled('picture')(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    img: {
        width: '100%',
    },
}))

export const StyledPromoBannerWrap = styled('picture')(({ theme }) => ({
    display: 'flex',
    marginBottom: calcRem(30),
    img: {
        width: '100%',
    },
}))

export const StyledTW1000PromoBannerTCs = styled('a')(({ theme }) => ({
    position: 'absolute',
    justifySelf: 'center',
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 400,
    color: colors.black,
    bottom: calcRem(16),
    right: '50%',
    transform: 'translateX(50%)',
    textDecoration: 'underline',
    fontSize: calcRem(12),
}))
